<template>


  <div id="app">

    
    <privacy-modal />
    <html-top ref="htmltop" />
    <nav-menu />
    <router-view />
    <html-footer />
  </div>
</template>

<script>
import HtmlFooter from "./components/common/HtmlFooter.vue";
import HtmlTop from "./components/common/HtmlTop.vue";
import NavMenu from "./components/common/NavMenu.vue";
import PrivacyModal from "./components/index/PrivacyModal.vue";

export default {
  name: "App",
  components: {
    HtmlFooter,
    HtmlTop,
    NavMenu
    ,PrivacyModal
  },
  data(){            
      return {
          ua:navigator.userAgent.toLowerCase()
          
      }
  },
  methods:{
    isMobile() {
      const ua = navigator.userAgent.toLowerCase();

      const isWeChat = /wechat/.test(ua); // 是否是微信浏览器
      console.log(ua);
      // const isWeChatPC = isWeChat && (/windows/.test(ua) || /mac/.test(ua)); // 是否是PC端微信
      const isMobileDevice = /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone)/.test(ua);

      return isMobileDevice || isWeChat;
    }
  },


  // watch: {
  //   windowWidth(val) {
  //     if (val < 768) {
  //       window.open("https://wap.movibot-art.com/");
  //     }
  //   }
  // }
  mounted() {
    this.$nextTick(() => {
       if (this.isMobile()) {
          window.location.href = "https://wap.movibot-art.com/";
        }
    });
  }

    // this.$nextTick(() => {
    //   var appDivWidth = window.innerWidth;
    //   console.log(appDivWidth, "appDivWidth");
    //   if (appDivWidth < 1201) {
    //     window.location.href = "https://wap.movibot-art.com/";
    //     // var tempwindow = window.open("_blank"); //打开一个窗口，然后用

    //     // tempwindow.location = "https://wap.movibot-art.com/";
    //   }
    // });
  
};
</script>
<style>
.el-dropdown-menu__item:hover {
  background-color: #fff !important;
  color: #2655ae !important;
}
#app {
  min-width: 1200px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue